export default {
  authors: [],
  courses: [],
  navbar_items: [],
  blogs: [],
  schedules: { id: null, type: 'Schedule', header: '', venue: '', description: '', session_dates: [] },
  costs: [],
  classTypes: [],
  dietConsultations: { header: '', short: '', description: '', venue: '', consultationDetails: [] },
  massageTypes: [],
  testimonials: { header: '', short: '', description: '', testimonial_details: [] },
  eventTypes: [],
  upload: [],
  authToken: {
    token: null,
    user: null
  },
  error: ""
}



// WEBPACK FOOTER //
// ./src/reducers/initialState.js